<template>


    <div>

        <v-card-text>

            <v-layout>
                <v-flex xs6><strong>{{$t('erp.widgets.user')}}</strong></v-flex>
                <v-flex xs6><strong>{{$t('erp.widgets.last_activity')}}</strong></v-flex>
            </v-layout>

            <v-layout  v-for="session in activeUsers">
                <v-flex xs6>{{session.username}}</v-flex>
                <v-flex xs6>{{session.last_access|moment($t('erp.common.datetime_string'))}}</v-flex>
            </v-layout>

        </v-card-text>

    </div>



</template>


<script>

    export default {


        name: 'activeUsersWidget.vue',
        wconf: {

            title: 'dashboard.widget.title.active_users',
            location: 'secondary',
            position: 50,
            active: true,
            roles: ['admin']

        },

        data() {
            return {

                activeUsers: [],
                interval: null,

            }
        },

        methods: {


            getTitle(){

                return this.$t('dashboard.widget.title.active_users')

            },

            getSessions: function(){


                var self = this;

                self.$http.get('api/erp/v2/info/sessions').then((result) => {



                    self.activeUsers = result.data.payload.filter(session => session.is_guest == "no");



                });


            }

        },

        mounted: function () {


            var self = this;

            self.getSessions();
            self.interval = setInterval(function(){self.getSessions()},30000);


        },

        destroyed:  function(){

            var self=this;



            clearInterval(self.interval);


        },



    }



</script>
